import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

const data =[
    {
        "categoryName": "bp",
        "customerCount": 20
    },
    {
        "categoryName": "ball",
        "customerCount": 4
    },
    {
        "categoryName": "yoga",
        "customerCount": 2
    },
    {
        "categoryName": "kkcsd dd",
        "customerCount": 10
    },
    {
        "categoryName": "ball",
        "customerCount": 4
    },
    {
        "categoryName": "yoga",
        "customerCount": 2
    },
    {
        "categoryName": "kkcsd dd",
        "customerCount": 10
    },
    {
        "categoryName": "ball",
        "customerCount": 4
    },
    {
        "categoryName": "yoga",
        "customerCount": 2
    },
    {
        "categoryName": "kkcsd dd",
        "customerCount": 10
    },
    {
        "categoryName": "ball",
        "customerCount": 4
    },
    {
        "categoryName": "yoga",
        "customerCount": 2
    },
    {
        "categoryName": "kkcsd dd",
        "customerCount": 10
    },
    {
        "categoryName": "ball",
        "customerCount": 4
    },
    {
        "categoryName": "yoga",
        "customerCount": 2
    },
    {
        "categoryName": "kkcsd dd",
        "customerCount": 10
    },
    {
        "categoryName": "ball",
        "customerCount": 4
    },
    {
        "categoryName": "yoga",
        "customerCount": 2
    },
    {
        "categoryName": "kkcsd dd",
        "customerCount": 10
    },
    {
        "categoryName": "ball",
        "customerCount": 4
    },
    {
        "categoryName": "yoga",
        "customerCount": 2
    },
    {
        "categoryName": "kkcsd dd",
        "customerCount": 10
    },
    {
        "categoryName": "ball",
        "customerCount": 4
    },
    {
        "categoryName": "yoga",
        "customerCount": 2
    },
    {
        "categoryName": "kkcsd dd",
        "customerCount": 10
    }
]
function getRandomDarkColor() {
  const r = Math.floor(Math.random() * 128); // Random red component (0-127)
  const g = Math.floor(Math.random() * 128); // Random green component (0-127)
  const b = Math.floor(Math.random() * 128); // Random blue component (0-127)
  return `rgb(${r},${g},${b})`;
} const dataset = data.map((category) => {
    return { ...category, color: getRandomDarkColor() };
  });
//   console.log(dataset);

  

// Example usage:
export default function WellnessChart(props:any) {
    // console.log(props?.list);

  return (
    <>
    <h3 className="f-20 fw-600">{props?.title}</h3>

    <div className="no-scroolbar" style={{ width: '100%', height: '350px', overflowX: 'auto' }}>
  <BarChart
    width={data.length * 50} // Adjust the width based on the number of data points
    height={300}
    data={props?.list}
    margin={{
      top: 5,
      right: 30,
      left: 20,
      bottom: 5
    }}
  >
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="Categoryname" />
    <YAxis />
    <Tooltip />
    <Bar dataKey="Customercount" fill="#8884d8" />
  </BarChart>
</div>
</>

  );
}
